import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Paper, Typography } from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

const MORE_VALUE = '__more__';

const MobileBottomNav = ({ primaryItems, onMoreClick }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const activePrimary = primaryItems.find(
    (item) =>
      location.pathname === item.path ||
      (item.path !== '/' && location.pathname.startsWith(item.path))
  );

  const currentValue = activePrimary?.path ?? MORE_VALUE;

  const handleSelect = (path) => {
    if (path === MORE_VALUE) {
      onMoreClick();
      return;
    }
    navigate(path);
  };

  const tabs = [
    ...primaryItems.map((item) => ({
      value: item.path,
      label: item.shortLabel || item.text,
      Icon: item.Icon,
    })),
    { value: MORE_VALUE, label: 'More', Icon: MoreHorizIcon },
  ];

  return (
    <Paper
      elevation={0}
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: (t) => t.zIndex.appBar,
        borderTop: '1px solid',
        borderColor: 'divider',
        bgcolor: 'rgba(255, 255, 255, 0.92)',
        backdropFilter: 'blur(12px)',
        pb: 'env(safe-area-inset-bottom, 0px)',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'stretch',
          justifyContent: 'space-around',
          minHeight: 64,
          maxWidth: 600,
          mx: 'auto',
        }}
      >
        {tabs.map(({ value, label, Icon }) => {
          const isActive = currentValue === value;
          return (
            <Box
              key={value}
              component="button"
              type="button"
              onClick={() => handleSelect(value)}
              aria-label={label}
              aria-current={isActive ? 'page' : undefined}
              sx={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 0.375,
                py: 0.75,
                px: 0.5,
                border: 'none',
                bgcolor: 'transparent',
                cursor: 'pointer',
                color: isActive ? 'primary.main' : 'text.secondary',
                transition: 'color 0.15s ease',
                WebkitTapHighlightColor: 'transparent',
                '&:active': { opacity: 0.7 },
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: 48,
                  height: 28,
                  borderRadius: 2,
                  bgcolor: isActive ? 'rgba(90, 103, 216, 0.12)' : 'transparent',
                  transition: 'background-color 0.15s ease',
                }}
              >
                <Icon sx={{ fontSize: 22 }} />
              </Box>
              <Typography
                sx={{
                  fontSize: '0.6875rem',
                  fontWeight: isActive ? 600 : 500,
                  lineHeight: 1.2,
                  letterSpacing: '0.01em',
                }}
              >
                {label}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Paper>
  );
};

export default MobileBottomNav;
